export const UPDATE_COMMENT_BY_TARGET_ACTUAL_SUCCESS = 'UPDATE_COMMENT_BY_TARGET_ACTUAL_SUCCESS';

export const updateCommentByTargetActualSuccess = ( targetActual ) => ({
    type: UPDATE_COMMENT_BY_TARGET_ACTUAL_SUCCESS,
    payload: {
        targetActual,
    },
});
